import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { ButtonModule } from '@avenir-client-web/button';
import { ButtonModule as PButtonModule } from 'primeng/button';

@Component({
  selector: 'app-dialog-content-layout',
  templateUrl: './dialog-content-layout.component.html',
  styleUrls: ['./dialog-content-layout.component.scss'],
  imports: [CommonModule, PButtonModule, ButtonModule],
})
export class DialogContentLayoutComponent {
  @Input() actionButtonsTemplate: TemplateRef<unknown>;

  @Input() saveLabel = $localize`default.action.save`;

  @Input() cancelLabel = $localize`default.action.cancel`;

  @Input() additionalLabel = '';

  @Input() displayedAddtionalBtn = false;

  @Output() confirmationCloseEvent = new EventEmitter<void>();

  @Output() closeEvent = new EventEmitter<void>();

  @Output() saveEvent = new EventEmitter<void>();

  @Output() additionalEvent = new EventEmitter<void>();

  @HostListener('document: click', ['$event'])
  click(event: Event): void {
    event.stopPropagation();
    const el = event.target as HTMLElement;

    if (el.classList.contains('p-dialog-mask')) {
      if (el.querySelectorAll('.confirmation-dialog').length)
        this.confirmationCloseEvent.emit();
      else this.closeEvent.emit();
    }
  }
}
